import { gql } from "@apollo/client";

export const DetailHeroFragment = gql`
  fragment DetailHero on DetailHero {
    includeTimeInfo
    timeText
    timeSubtext
    dateSubtext
    location
    locationSubtext
    accessibilityFriendly
    accessibilitySubtext
    assetType
    video
    videoThumbnail {
      ...ACFMedia
    }
    image {
      ...ACFMedia
    }
  }
`;